module.exports = __webpack_public_path__ + "img/full6-min.42d9fe43.png";